import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

import { STORE_SENT_MESSAGE, RECEIVE_NEW_MESSAGE, HISTORY_MESSAGES_LOADED, SAVE_MESSAGE_DRAFT } from "./Types";
var initialState = {
  messages: {},
  messageDrafts: {}
};
export function MessageReducer(state, action) {
  var _a, _b, _c, _d, _e, e_1, _f;

  if (state === void 0) {
    state = initialState;
  }

  switch (action.type) {
    case SAVE_MESSAGE_DRAFT:
      return __assign(__assign({}, state), {
        messageDrafts: __assign(__assign({}, state.messageDrafts), (_a = {}, _a[action.to.chatId.encode()] = action.draft, _a))
      });

    case STORE_SENT_MESSAGE:
      if (action.originalMessage.type === "text") {
        return __assign(__assign({}, state), {
          messages: __assign(__assign({}, state.messages), (_b = {}, _b[action.message.id] = action.message, _b)),
          messageDrafts: __assign(__assign({}, state.messageDrafts), (_c = {}, _c[action.originalMessage.to.chatId.encode()] = "", _c))
        });
      } else {
        return __assign(__assign({}, state), {
          messages: __assign(__assign({}, state.messages), (_d = {}, _d[action.message.id] = action.message, _d))
        });
      }

    case RECEIVE_NEW_MESSAGE:
      return __assign(__assign({}, state), {
        messages: __assign(__assign({}, state.messages), (_e = {}, _e[action.message.id] = action.message, _e))
      });

    case HISTORY_MESSAGES_LOADED:
      var historyMessages = {};

      try {
        for (var _g = __values(action.historyMessages), _h = _g.next(); !_h.done; _h = _g.next()) {
          var m = _h.value;
          historyMessages[m.id] = m;
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_h && !_h.done && (_f = _g["return"])) _f.call(_g);
        } finally {
          if (e_1) throw e_1.error;
        }
      }

      return __assign(__assign({}, state), {
        messages: __assign(__assign({}, state.messages), historyMessages)
      });

    default:
      return state;
  }
}